export default __webpack_public_path__ + "img/ca8dec7a756e334318606ff2d2e06d64.png";